export default { sha: 'dev', buildNumber: 'dev' }
